import { render, staticRenderFns } from "./SortLink.vue?vue&type=template&id=a95d4b86&scoped=true&"
import script from "./SortLink.vue?vue&type=script&lang=js&"
export * from "./SortLink.vue?vue&type=script&lang=js&"
import style0 from "./SortLink.vue?vue&type=style&index=0&id=a95d4b86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95d4b86",
  null
  
)

export default component.exports